import * as React from "react"
import { Link } from "gatsby"

const Header = ({ brand, links, social, modeSwitcher }) => {
  const canSwitchMode = modeSwitcher || false
  const headerLinks = (<ol className="menu-items">
    {links.map((link, index) => <li key={index}>{link}</li>)}
  </ol>)
  const soc = Object.keys(social).map((title, index) => {
    const { link, icon } = social[title]
    return <a href={link} key={index}>{icon}</a>
  })
  return (
    <div className="header">
      <div className="container">
        <span className="brand"><Link to="/">{brand}</Link></span>
        {headerLinks}
        <div className="pull-right">
          {soc}
        </div>
      </div>
    </div>
  )
}

export default Header
